// OCE-600: CMS/timer payload is user-editable upstream; guard against
// broken or hostile URLs before feeding them into navigation or CSS.

/**
 * True iff `value` parses as an absolute http(s) URL. Rejects javascript:,
 * data:, relative paths, empty strings, and anything that URL() can't parse.
 */
export function isValidHttpUrl(value: unknown): value is string {
  if (typeof value !== 'string' || value.trim().length === 0) {
    return false
  }
  let parsed: URL
  try {
    parsed = new URL(value)
  } catch {
    return false
  }
  return parsed.protocol === 'http:' || parsed.protocol === 'https:'
}
